import { render, staticRenderFns } from "./FacilitiesItem.vue?vue&type=template&id=34389ec7&scoped=true"
import script from "./FacilitiesItem.vue?vue&type=script&lang=ts"
export * from "./FacilitiesItem.vue?vue&type=script&lang=ts"
import style0 from "./FacilitiesItem.vue?vue&type=style&index=0&id=34389ec7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34389ec7",
  null
  
)

export default component.exports